import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/auth';
import { Link } from 'react-router-dom';
import moment from 'moment';
import '../../src/Hero2.css';
import Slide from 'react-reveal/Slide';





function Header(props) {
  const [nav, setNav] = useState('container-fluid nav d-none d-xl-block  ');
  const [navbar, setNavbar] = useState('container-fluid nav2 d-block d-xl-none  navbar fixed-top')

  const controlNavbar = () => {
    if (window.scrollY > 30) {
      setNav('container-fluid nav active d-none d-xl-block  ')
      setNavbar('container-fluid nav2 active d-block d-xl-none  navbar fixed-top ')
    } else {
      setNav('container-fluid nav d-none d-xl-block ')
      setNavbar('container-fluid nav2 d-block d-xl-none  navbar fixed-top ')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', controlNavbar)
    return () => window.addEventListener('scroll', controlNavbar)
  });


  return (
    <div className=' row'>

      <div className='col-md-12'>

      </div>

      <div className={nav} id='header'>
        <div className='container'>

          {/*  <img className='img-fluid logoNav' src='imagenes/Sygreca.png' /> */}
          <a className='logo' href='/'>
            <img className='img-fluid logosygre' src='imagenes/sygreca2.png' /></a>

          <ul>
            <li><a href='/' className='a current'>INICIO</a></li>
            <li><a href='/productos' className='a'>PRODUCTOS</a></li>
         {/*    <li><a href='/servicios' className='a'>SERVICIOS</a></li> */}
          {/*   <li><a href='/clientes' className='a'>CLIENTES</a></li> */}
            <li><a href='/quienessomos' className='a'>QUIENES SOMOS</a></li>
          </ul>

        </div>


      </div>
      {/*  */}

      <nav className={navbar}>
        <div className="container">
          <div className='row w-100 mx-auto d-md-flex justify-content-between' >

            <h1 className="col logo2" href="#"><a type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" href='#'> <i className="fa-solid fa-bars"></i>SYGRECA</a></h1>



          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">

              <li className="nav-item">
                <a className="nav-link" href="#">
                  <img className='img-fluid logosygre2 d-none d-xl-block' src='imagenes/sygreca2.png' />
                </a>
              </li>
              <li className="nav-item">

                <Link
                  to="/productos"
                  className="nav-link">
                  <i className="nav-link a" />
                  <p>PRODUCTOS</p>
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link a" href="#">SERVICIOS</a>
              </li>
              <li className="nav-item">
                <a className="nav-link a" href="#">CLIENTES</a>
              </li>


            </ul>

          </div>
        </div>
      </nav>



    </div>
  );









}

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js